// import request from '@/utils/request'
import { get, post, put, remove } from '@/utils/http.js'

import { praseStrEmpty } from "@/utils/ruoyi";


// export function getConfigKey(configKey) {
//     return request({
//       url: '/system/config/configKey/' + configKey,
//       method: 'get'
//     })
//   }
export const getConfigKey = (configKey) => get('/system/config/configKey/' + configKey)


// 查询用户列表
// export function listUser(query) {
//     return request({
//         url: '/system/user/list',
//         method: 'get',
//         params: query
//     })
// }
export const listUser = (query) => get('/system/user/list', query);

// 查询用户详细
// export function getUser(userId) {
//     return request({
//         url: '/system/user/' + praseStrEmpty(userId),
//         method: 'get'
//     })
// }
export const getUser = (userId) => get('/system/user/' + praseStrEmpty(userId));

// 新增用户
// export function addUser(data) {
//     return request({
//         url: '/system/user',
//         method: 'post',
//         data: data
//     })
// }
export const addUser = (data) => post('/system/user', data);

// 修改用户
// export function updateUser(data) {
//     return request({
//         url: '/system/user',
//         method: 'put',
//         data: data
//     })
// }
export const updateUser = (data) => put('/system/user', data);

// 删除用户
// export function delUser(userId) {
//     return request({
//         url: '/system/user/' + userId,
//         method: 'delete'
//     })
// }
export const delUser = (userId) => remove('/system/user/' + userId);

// 导出用户
// export function exportUser(query) {
//     return request({
//         url: '/system/user/export',
//         method: 'get',
//         params: query
//     })
// }
export const exportUser = (query) => get('/system/user/export', query);

// 用户密码重置
export function resetUserPwd(userId, password) {
    const data = {
        userId,
        password
    }
    return put('/system/user/resetPwd', data)
    // return request({
    //     url: '/system/user/resetPwd',
    //     method: 'put',
    //     data: data
    // })
}

// 用户状态修改
export function changeUserStatus(userId, status) {
    const data = {
        userId,
        status
    }
    return put('/system/user/changeStatus', data);
    // return request({
    //     url: '/system/user/changeStatus',
    //     method: 'put',
    //     data: data
    // })
}

// 查询用户个人信息
// export function getUserProfile() {
//     return request({
//         url: '/system/user/profile',
//         method: 'get'
//     })
// }
export const getUserProfile = () => get('/system/user/profile');

// 修改用户个人信息
// export function updateUserProfile(data) {
//     return request({
//         url: '/system/user/profile',
//         method: 'put',
//         data: data
//     })
// }
export const updateUserProfile = (data) => put('/system/user/profile', data);

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
    const data = {
        oldPassword,
        newPassword
    }
    return put('/system/user/profile/updatePwd', data);
    // return request({
    //     url: '/system/user/profile/updatePwd',
    //     method: 'put',
    //     params: data
    // })
}

// 用户头像上传
// export function uploadAvatar(data) {
//     return request({
//         url: '/system/user/profile/avatar',
//         method: 'post',
//         data: data
//     })
// }
export const uploadAvatar = (data) => post('/system/user/profile/avatar', data);

// 下载用户导入模板
// export function importTemplate() {
//     return request({
//         url: '/system/user/importTemplate',
//         method: 'get'
//     })
// }
export const importTemplate = () => get('/system/user/importTemplate');
